import { useTranslation } from "react-i18next";
import { LogIn } from "lucide-react";
import { LangToggle } from "../components/LangToggle";
import { ThemeToggle } from "../components/ThemeToggle";
import { authLoginHref } from "../lib/i18n";
import { useLoginNavigation } from "../components/LoginLink";

/** อนุญาตเฉพาะ path ภายใน กัน open redirect */
export function safeNext(next: string | undefined): string {
  if (!next || !next.startsWith("/") || next.startsWith("//")) return "/app";
  return next;
}

export function LoginPage({ next }: { next: string | undefined }) {
  const { t } = useTranslation();
  const target = safeNext(next);
  const { pending, start } = useLoginNavigation();
  return (
    <main id="main" className="flex min-h-dvh flex-col items-center justify-center gap-6 p-6">
      <div className="absolute top-3 right-3 flex gap-1">
        <LangToggle />
        <ThemeToggle />
      </div>
      <div className="w-full max-w-sm rounded-xl border border-border bg-surface p-8 text-center shadow-sm">
        <h1 className="text-2xl font-semibold">{t("app.name")}</h1>
        <p className="mt-2 text-sm text-muted">{t("login.subtitle")}</p>
        <button
          type="button"
          className="btn btn-primary mt-6 w-full justify-center py-2.5"
          disabled={pending}
          aria-busy={pending}
          onClick={() => start(authLoginHref({ next: target }))}
        >
          <LogIn size={16} aria-hidden /> <span role={pending ? "status" : undefined}>{t(pending ? "login.pending" : "login.button")}</span>
        </button>
      </div>
    </main>
  );
}

/**
 * [T-085 · #245] `?verified=0` (worker เทียบ state cookie ตอนกลับจาก end-session ไม่ผ่าน)
 * → แสดงข้อความ unverified แทน body ปกติ · ค่าอื่น/ไม่มี param → หน้าเดิม
 */
export function LoggedOutPage() {
  const { t } = useTranslation();
  const unverified = new URLSearchParams(window.location.search).get("verified") === "0";
  return (
    <main id="main" className="flex min-h-dvh flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="text-2xl font-semibold">{t("loggedOut.title")}</h1>
      <p className="text-muted">{unverified ? t("loggedOut.unverified") : t("loggedOut.body")}</p>
      <a href="/login" className="btn btn-primary">
        {t("loggedOut.again")}
      </a>
    </main>
  );
}
